import { MessageType } from '@savgroup-front-common/types';

import {
  TRANSPORT_METHOD_TYPE,
  TransportMethodType,
} from '../../api/Claim/getClaimGroupTransportPlanQuery';

import messages from './messages';

export const getHandlingCardLabel = ({
  transportMethodType,
}: {
  transportMethodType?: TransportMethodType;
}): {
  label: MessageType | string;
  highlighting: MessageType | string | undefined;
  description: MessageType | string;
} => {
  switch (transportMethodType) {
    case TRANSPORT_METHOD_TYPE.RelayPointDeposit: {
      return {
        label: messages.relayPointDeposit,
        highlighting: undefined,
        description: messages.relayPointDepositDescription,
      };
    }
    case TRANSPORT_METHOD_TYPE.OnSiteCollection: {
      return {
        label: messages.onSiteCollection,
        highlighting: undefined,
        description: messages.onSiteCollectionDescription,
      };
    }
    case TRANSPORT_METHOD_TYPE.HomeDelivery: {
      return {
        label: messages.homeDelivery,
        highlighting: undefined,
        description: messages.homeDeliveryDescription,
      };
    }

    case TRANSPORT_METHOD_TYPE.HomePickup: {
      return {
        label: messages.homePickup,
        highlighting: undefined,
        description: messages.homePickupDescription,
      };
    }

    case TRANSPORT_METHOD_TYPE.PickUpRelayPointDelivery: {
      return {
        label: messages.pickUpStationDelivery,
        highlighting: undefined,
        description: messages.pickUpStationDeliveryDescription,
      };
    }
    case TRANSPORT_METHOD_TYPE.DropAtStoreDeposit: {
      return {
        label: messages.dropAtStoreDeposit,
        highlighting: messages.dropAtStoreDepositHighlighting,
        description: messages.dropAtStoreDepositDescription,
      };
    }

    case TRANSPORT_METHOD_TYPE.HomePickupProvidedBySeller: {
      return {
        label: messages.externalHomePickup,
        highlighting: undefined,
        description: messages.externalHomePickupDescription,
      };
    }

    case TRANSPORT_METHOD_TYPE.PickUpStoreDelivery: {
      return {
        label: messages.pickUpStoreDelivery,
        highlighting: messages.pickUpStoreDeliveryHighlighting,
        description: messages.pickUpStoreDeliveryDescription,
      };
    }
    case TRANSPORT_METHOD_TYPE.ImmediateDropAtStoreDeposit: {
      return {
        label: messages.immediateDropAtStoreDeposit,
        highlighting: undefined,
        description: messages.immediateDropAtStoreDepositDescription,
      };
    }
    case TRANSPORT_METHOD_TYPE.LabelProvidedBySeller: {
      return {
        label: messages.sellerProvidedCarrier,
        highlighting: undefined,
        description: messages.sellerProvidedCarrierDescription,
      };
    }
    case TRANSPORT_METHOD_TYPE.LabelProvidedByCustomer: {
      return {
        label: messages.selfDepositCarrier,
        highlighting: undefined,
        description: messages.selfDepositCarrierDescription,
      };
    }

    case TRANSPORT_METHOD_TYPE.HomeIntervention: {
      return {
        label: messages.homeIntervention,
        highlighting: undefined,
        description: messages.homeInterventionDescription,
      };
    }

    case TRANSPORT_METHOD_TYPE.BulkyHomeDelivery: {
      return {
        label: messages.bulkyHomeDelivery,
        highlighting: undefined,
        description: messages.bulkyHomeDeliveryDescription,
      };
    }

    default:
      return {
        label: transportMethodType ?? '',
        highlighting: undefined,
        description: '',
      };
  }
};
